import { Link } from 'react-router-dom';
import { categories } from '@/mocks/site';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            内容分类
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            八大分类，覆盖全类型影片，总有一款适合您
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-lg overflow-hidden aspect-[4/3] bg-background-200"
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-center gap-2 mb-1">
                  <span className="flex items-center justify-center w-7 h-7 rounded-full bg-primary-500/80">
                    <i className={`${cat.icon} text-white text-xs`} />
                  </span>
                  <h3 className="font-heading font-semibold text-white text-sm md:text-base">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-white/60 text-xs hidden md:block">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}